module.exports = __webpack_public_path__ + "img/Weapon_86.393096b1.png";